import React, {useState} from 'react';
import {Tooltip, Errors} from '../../../partials/Partials';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSquare, faTrophy} from "@fortawesome/free-solid-svg-icons";
import PremiumLawyersBenefits from './PremiumLawyersBenefits';
import { useEffect } from 'react';

function Completness_Widget(props) {
    const [data, setData] = useState({});
    const [errors, setErrors] = useState([]);
    const {is_premium} = props
    const {completed, section} = data || '';

    useEffect(() => {
        fetch('/api/lawyer_profiles_extended/current/missing_data/').then(res => res.json().then(data => 
            {
                setData(data)
            }
        )).catch((err) => {
            setErrors([err])
        })
    }, [])
    
    let message = '';
    let first_url = ''

    if (section && section.length > 0) {
        const {url} = section[0];
        first_url = url
    } 

    if (completed)
        if (completed <= 45) {
            message = 'Twój profil nie wygląda jeszcze zbyt profesjonalnie dla potencjalnych klientów'
        } else if (completed > 45 && completed <= 75) {
            message = 'Twój profil nie wygląda jeszcze w pełni profesjonalnie dla potencjalnych klientów'
        } else {
            message = 'Twój profil wygląda już prawie w pełni profesjonalnie! Uzupełnij jeszcze brakujące elementy i zdobywaj więcej wyświetleń!'
        }

        if (completed !== undefined && completed !== 100) {
            return(
            <div className="completness-widget">
                <Errors errors={errors}/>
                <Header 
                    completed={completed} 
                    first_link={first_url}
                />
                <ProgressBar completed={completed}/>
                <Tooltip text1={message}/>
                <UncompletedList uncompleted_sections={section}/>
                <PremiumLawyersBenefits is_premium={is_premium} />
            </div>
            
        )
        } else if (completed === 100) {
            return(
                <Certyfikat />
            )
        }
    } 

class Header extends React.Component {
    render() {
        const {completed, first_link} = this.props
        return(
            <div className="header bottom-buffer">
                <h4>{completed}% wypełnienia profilu</h4>
                <a href={first_link} className="btn btn-sm btn-danger pull-right">Popraw swój profil</a>
            </div>
        )
    }
}

class ProgressBar extends React.Component {
    render() {
        const {completed} = this.props
        return(
            <div className="completness-progress-bar-vertical-line progress">
                <div className='progress-bar progress-bar-primary' style={{width:`${completed}%`}}>
                    <div className="progress-bar-pointer"></div>
                </div>
            </div>
        )
    }
}


class UncompletedList extends React.Component {
    render() {
        const {uncompleted_sections} = this.props
        let names = [];
        
        if (uncompleted_sections && uncompleted_sections.length > 0)
        uncompleted_sections.map((item, i) => {
            names.push(
                <li className="pointer" key={i}>
                    <a href={item.url}>
                        <FontAwesomeIcon icon={faSquare} className='fa-square'/>
                        {item.name}
                    </a>
                </li>
            ) 
            return names;
        })

        return(
            <ul className="top-buffer">
                {names}
            </ul>
        )
    }
}

class Certyfikat extends React.Component {
    render() {
        return(
            <div className="alert alert-success">
                <h4 className="text-center">
                    <FontAwesomeIcon icon={faTrophy} className='fa-trophy'/>
                    Wypełniłeś 100% swojego profilu!
                </h4>
            </div>
        )
    }
}

export default Completness_Widget;